import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import { useSiteImport } from "./useSiteImport";
import type { FormFields } from "./useSiteImport";
import { SiteImportForm } from "./SiteImportForm";
import { SiteImportResults } from "./SiteImportResults";
import type { JSX } from "react";

export function SiteImport() {
  let siteImport: JSX.Element;
  const { state, submitParse, confirmSave, reset } = useSiteImport();
  const navigate = useNavigate();
  const goToSites = () => {
    void navigate("/sites");
  };
  const handleParse = (form: FormFields) => {
    void submitParse(form);
  };
  if (state.kind === "form") {
    siteImport = (
      <Box p={3} maxWidth={900}>
        <SiteImportForm onSubmit={handleParse} />
      </Box>
    );
  } else {
    if (state.kind === "parsing") {
      siteImport = (
      <Box p={3} maxWidth={900} display="flex" alignItems="center" gap={2}>
        <CircularProgress size={24} />
        <Typography>Парсинг…</Typography>
      </Box>
    );
    } else {
      if (state.kind === "results") {
        siteImport = (
      <Box p={3} maxWidth={1600}>
        <SiteImportResults
          entries={state.entries}
          parseErrors={state.parseErrors}
          summary={state.summary}
          seller={state.form.seller}
          onConfirm={confirmSave}
          onCancel={reset}
        />
      </Box>
    );
      } else {
        if (state.kind === "saving") {
          siteImport = (
      <Box p={3} maxWidth={900} display="flex" alignItems="center" gap={2}>
        <CircularProgress size={24} />
        <Typography>Сохранение…</Typography>
      </Box>
    );
        } else {
          if (state.kind === "success") {
            siteImport = (
      <Box p={3} maxWidth={900}>
        <Alert severity="success" sx={{ mb: 2 }}>
          Импорт завершён: добавлено {state.result.addedCredentials} доступов,
          пропущено дубликатов: {state.result.skippedDuplicates},
          восстановлено сайтов: {state.result.restoredSites}.
        </Alert>
        <Box display="flex" gap={1}>
          <Button variant="contained" onClick={goToSites}>
            К списку сайтов
          </Button>
          <Button variant="outlined" onClick={reset}>
            Новый импорт
          </Button>
        </Box>
      </Box>
    );
          } else {
            siteImport = (
    <Box p={3} maxWidth={900}>
      <Alert severity="error" sx={{ mb: 2 }}>
        {state.message}
      </Alert>
      <Box display="flex" gap={1}>
        <Button variant="contained" onClick={reset}>
          Попробовать снова
        </Button>
        <Button variant="outlined" onClick={goToSites}>
          К списку сайтов
        </Button>
      </Box>
    </Box>
  );
          }
        }
      }
    }
  }
  return siteImport;
}
